/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KioskConfigDto } from '../../models/kiosk-config-dto';
import { UpdateKioskConfigDto } from '../../models/update-kiosk-config-dto';

export interface KioskConfigControllerUpdateV1$Params {
  sourceType: string;
      body: UpdateKioskConfigDto
}

export function kioskConfigControllerUpdateV1(http: HttpClient, rootUrl: string, params: KioskConfigControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<KioskConfigDto>> {
  const rb = new RequestBuilder(rootUrl, kioskConfigControllerUpdateV1.PATH, 'put');
  if (params) {
    rb.path('sourceType', params.sourceType, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KioskConfigDto>;
    })
  );
}

kioskConfigControllerUpdateV1.PATH = '/api/v1/kiosk-config/{sourceType}';
